/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_SubtitleInputs */

const cs_documents_subtitle = /** @type {(inputs: Documents_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledání souborů, složky a sdílení.`)
};

const en_documents_subtitle = /** @type {(inputs: Documents_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search files, open folders, create shares.`)
};

/**
* | output |
* | --- |
* | "Search files, open folders, create shares." |
*
* @param {Documents_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_subtitle = /** @type {((inputs?: Documents_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_subtitle(inputs)
	return cs_documents_subtitle(inputs)
});